import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconResetSize = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon/reset-size",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Rectangle 34624193 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V19C4.5 19.2761 4.72386 19.5 5 19.5H19C19.2761 19.5 19.5 19.2761 19.5 19V5C19.5 4.72386 19.2761 4.5 19 4.5ZM5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5Z",
			fill: "#959595"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 145 (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 7.25H16.75V12H15.25V9.81066L9.81066 15.25H12V16.75H7.25V12H8.75V14.1893L14.1893 8.75H12V7.25Z",
			fill: "#959595"
		})]
	})
});
export default SvgIconResetSize;
